var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview"},_vm._l((_vm.files),function(file){return _c('div',{key:file.name,class:['preview-card', { multiple: _vm.files.length > 1 }]},[_c('div',{staticClass:"file-info"},[_c('small',[_vm._v(_vm._s(file.name))]),_c('small',[_vm._v(_vm._s(_vm.formatBytes(file.size)))])]),_c('button',{staticClass:"btn ml-2",attrs:{"type":"button","title":"Remove file"},on:{"click":function($event){$event.stopPropagation();_vm.onRemove(_vm.files.indexOf(file))}}},[_c('NbIcon',{attrs:{"icon":"x","attributes":{
          'stroke-width': 3,
          width: '1rem',
          height: '1rem',
        }}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }